import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {MutableRefObject, useEffect, useRef} from 'react'
import {ToggleComponent} from '../../../assets/ts/components'
import { UncheckedshowAdminPagesState, UpdateCurrentPopupId, updateSubMenusForDisplay } from '../../../../common/GlobalSlice'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'

type PropsType = {
  sidebarRef: MutableRefObject<HTMLDivElement | null>
}

const SidebarLogo = (props: PropsType) => {
  const {showSubMenus} = useAppSelector((state)=> state.globalState);
  const {config} = useLayout()
  const toggleRef = useRef<HTMLDivElement>(null)
    const dispatch = useAppDispatch();

  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
    ? 'minimize'
    : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default

  useEffect(() => {
    
    setTimeout(() => {
      const toggleObj = ToggleComponent.getInstance(toggleRef.current!) as ToggleComponent | null

      if (toggleObj === null) {
        return
      }

      // Add a class to prevent sidebar hover effect after toggle click
      toggleObj.on('kt.toggle.change', function () {
        // Set animation state
        props.sidebarRef.current!.classList.add('animating')

        // Wait till animation finishes
        setTimeout(function () {
          // Remove animation state
          props.sidebarRef.current!.classList.remove('animating')
        }, 300)
      })
    }, 600)
  }, [toggleRef, props.sidebarRef])

  const handleLinkClick = () => {
    localStorage.setItem('objAdmin', JSON.stringify(false));
    dispatch(UncheckedshowAdminPagesState());
  };

  const handleSideBarOpen =()=>{
    dispatch(updateSubMenusForDisplay(!showSubMenus));
    dispatch(UpdateCurrentPopupId(null));
  }

  return (
   <div className='app-sidebar-logo' id='kt_app_sidebar_logo'>
     <Link to='/dashboard' onClick={handleLinkClick}>
  {config.layoutType === 'dark-sidebar' ? (
     <></>
  ) : (
    <>
      <img
        alt='Logo'
        src={toAbsoluteUrl('/media/logos/livetecs-Icon.svg')}
        className='h-40px app-sidebar-logo-minimize mb-3 px-6'
        style={{ marginLeft: -5 }}
      />
      <img
        alt='Logo'
        src={toAbsoluteUrl('/media/logos/LivetecsLogo.svg')}
        className='h-30px app-sidebar-logo-default theme-light-show mb-3 px-3'
        style={{ marginLeft: 12 }}
      />
    </>
  )}
</Link>
 
    {/* <div> */}
    
      {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          ref={toggleRef}
          id='kt_app_sidebar_toggle'
          className={clsx(
            'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute start-100 translate-middle rotate mt-6',
            {active: true}
          )}
          data-kt-toggle='true'
          data-kt-toggle-state={toggleState}
          data-kt-toggle-target='body'
          data-kt-toggle-name={`app-sidebar-${toggleType}`}
          // style={{marginTop:25}}
          onClick={handleSideBarOpen}
        >
          <KTIcon iconName='double-left' className='fs-2 rotate-180' />
        </div>
      )}
    </div>
  )
}

export {SidebarLogo}
